// Prize pack rarity tiers. Prize weights run 1 (rarest) to 20 (most common);
// lower weight maps to a rarer, flashier tier. Shared between the manager-side
// weight editor and the player-facing prize pack display so the rarity labels
// and colors stay in sync.

export const RARITY_TIERS = [
  { max: 4, key: 'legendary', label: 'Legendary', color: '#f5a623' },
  { max: 8, key: 'epic', label: 'Epic', color: '#b15bd8' },
  { max: 12, key: 'rare', label: 'Rare', color: '#4A9ED7' },
  { max: 16, key: 'uncommon', label: 'Uncommon', color: '#39D365' },
  { max: 20, key: 'common', label: 'Common', color: '#b9b9c4' },
];

export function getRarity(weight) {
  if (weight === undefined || weight === null || isNaN(weight)) return null;
  const w = Math.max(1, Math.min(20, Number(weight)));
  return RARITY_TIERS.find(t => w <= t.max) ?? RARITY_TIERS[RARITY_TIERS.length - 1];
}
